/*
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-08-18 13:49:59
 * @LastEditors: wuzuojie 15727841808@163.com
 * @LastEditTime: 2023-08-05 18:04:50
 * @FilePath: \partner.chaoyongtuan.com\src\menus\talentCRM.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const talentCRM = [
	{
		path: '/talentCRM',
		redirect: '/talentCRM/myTalent',
		component: null,
		name: '达人',
		id: 2,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: true,
		useTemplate: false,
		children: [
			{
				path: 'myTalent',
				component: 'talentCRM/myTalent',
				name: '我的达人',
				parentId: 2,
				showBread: false,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'emphasisTalent',
				component: 'talentCRM/emphasisTalent/emphasisTalent',
				name: '重点关注达人',
				parentId: 2,
				showBread: false,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'groupSeas',
				component: 'talentCRM/groupSeas',
				name: '团队公海',
				parentId: 2,
				showBread: false,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'contacts',
				component: 'talentCRM/contacts',
				name: '联系人',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: true,
				children: null,
			},

			{
				path: 'clueSeas',
				component: 'talentCRM/clueSeas',
				name: '找达人',
				parentId: 2,
				showBread: false,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'myTalent/importLog',
				component: 'talentCRM/importLog',
				name: '导入记录',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: false,
				children: null,
			},
			{
				path: 'emphasisTalent/importLog',
				component: 'talentCRM/importLog',
				name: '导入记录',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: false,
				children: null,
			},
			{
				path: 'groupSeas/importLog',
				component: 'talentCRM/importLog',
				name: '导入记录',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: false,
				children: null,
			},
			{
				path: 'record',
				component: 'shopManage/orderDetails/record',
				name: '导出记录',
				parentId: 2,
				showBread: true,
				useTemplate: true,
				visible: false,
				children: null,
			},
			{
				path: 'allocatedrecord',
				component: 'talentCRM/allocatedRecord',
				name: '分配记录',
				parentId: 2,
				showBread: false,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'ruleManage',
				component: null,
				name: '规则管理',
				id: 3,
				redirect: '/talentCRM/ruleManage/list',
				parentId: 2,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				children: [
					{
						path: 'list',
						name: 'list',
						component: 'talentCRM/ruleManage/list',
						parentId: 3,
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'ruleSet',
						component: 'talentCRM/ruleManage/ruleSet',
						name: '规则设置',
						parentId: 3,
						showBread: true,
						useTemplate: true,
						visible: true,
						children: null,
					},
				],
			},
			{
				path: 'tagManagement',
				component: null,
				name: '标签管理',
				id: 8,
				parentId: 2,
				keepAlive: false,
				showBread: true,
				visible: true,
				useTemplate: false,
				redirect: '/talentCRM/tagManagement/list',
				children: [
					{
						path: 'list',
						name: 'list',
						component: 'talentCRM/tagManagement/list',
						parentId: 8,
						id: 899,
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
				],
			},
		],
	},
];
export default talentCRM;
